module.exports = __webpack_public_path__ + "img/12.94bc0bd2.png";